import request from "./../utils/request";

export async function getProductCategoryList(payload) {
  let query = serialize(payload);
  return request.get("ProductCategory/List?" + query);
}

export async function getCategoryAndProduct() {

  return new Promise((resolve, reject) => {

    request.get("Sale/List").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });

  });

}
export async function GetMobileOrderQuantity() {
  return (await request.get('Sale/mobile-order-quantity')).data;
}
export async function createNewProductCategory(newProductCategory) {
  return request.post("ProductCategory/Create", newProductCategory);
}
export async function updateProductCategory(productCategory) {
  return request.post("ProductCategory/Update", productCategory);
}
export async function deleteProductCategory(id) {
  return request.delete('ProductCategory/Delete?id=' + id);
}
export async function getCategoryNameList() {
  return request.get('ProductCategory/NameList');
}
export async function getProductableCategoryNameList() {
  return request.get('ProductCategory/ProductableNameList');
}
export async function getProductCategoryTreeList() {
  return request.get('ProductCategory/TreeList');
}
export async function deleteListFromCategory(list) {
  return request.post('ProductCategory/DeleteList',list);
}
export async function getExcludedProductsByCategory(id) {
  return request.get('Product/ExcludedProducts?catId=' + id);
}
export async function addProductToCategory(catId, productId, index) {
  return request.post("ProductCategory/AddProductToCategory", {
    catId: catId,
    productId: productId,
    index: index
  });
}
export async function uploadImage(image) {
  return request({
    method: 'post',
    url: 'UploadImage/',
    data: image,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  });
}

function serialize(obj, prefix) {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      var k = prefix ? prefix + "[" + p + "]" : p,
        v = obj[p];
      str.push((v !== null && typeof v === "object") ?
        serialize(v, k) :
        encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
  }
  return str.join("&");
}

export async function getProductCategories() {
  return request.get("ProductCategory/List");
}

export async function getCategoryDetail(categoryId) {
  return request.get("ProductCategory/CategoryDetail?categoryId=" + categoryId);
}
